import { useSelector } from "react-redux";

export const useAppSelector = (key) => {
  const selectedState = useSelector((state) => state[key]);
  if (!selectedState) {
    throw new Error("Please check your store. Required state not found.");
  }
  return selectedState;
};
